import { getColor } from '@/utils';
import { Card, CardContent, Typography } from '@mui/material';
import { MaterialReactTable } from 'material-react-table';
import { useTelematicsBoxAssignmentCounts } from './useTelematicsBoxAssignmentCounts';

const columns = [
  {
    accessorKey: 'assignments',
    header: 'Assignments',
    muiTableHeadCellProps: {
      align: 'right',
    },
    muiTableBodyCellProps: {
      align: 'right',
    },
    size: 0,
  },
  {
    accessorKey: 'boxes',
    header: 'Boxes',
    muiTableHeadCellProps: {
      align: 'right',
    },
    muiTableBodyCellProps: {
      align: 'right',
    },
    size: 0,
  },
];

// export function BoxAssignmentsCard({ groupCode }) {
export function BoxAssignmentsCard() {
  const {
    query: { data },
  } = useTelematicsBoxAssignmentCounts();

  return (
    <Card variant="outlined" sx={{ flex: 1 }}>
      <CardContent>
        <Typography variant="subtitle2" gutterBottom color="textSecondary">
          Telematics Box Assignments
        </Typography>
        <MaterialReactTable
          data={data}
          columns={columns}
          initialState={{ density: 'compact' }}
          enableTopToolbar={false}
          enableBottomToolbar={false}
          enableColumnActions={false}
          enableSorting={false}
          muiTableBodyRowProps={({ row }) => ({
            sx: getColor(row.getValue('assignments')),
            hover: false,
          })}
        />
      </CardContent>
    </Card>
  );
}
